import type RexRoute from 'teacher-ui-client/reporting/ui-scope/rex/route'
import RouteTemplate from 'ember-route-template'
import resetScroll from 'teacher-ui-client/modifiers/reset-scroll'
import Component from '@glimmer/component'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'

interface Signature {
  Args: {
    model: ModelFor<RexRoute>
  }
}

export class RexPage extends Component<Signature> {
  @service router!: RouterService

  get isDashboardTable() {
    return this.router.currentRouteName === 'reporting.ui-scope.rex.dashboard.table'
  }
  <template>
    <div
      class="{{if this.isDashboardTable 'relative flex flex-col'}} w-full"
      {{resetScroll onSetup=true onRouterChange=true}}
    >
      {{outlet}}
    </div>
  </template>
}

export default RouteTemplate(RexPage)
